import { CSSObject } from "@emotion/react";
import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { textXSObj } = typographyStyles;
const { mobileFirstCss } = mediaQueryStyles;

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { md },
}: { BreakpointNames: { md: string } } = constants.breakpoints;
const grey = constants.colors.ui.neutral[400];
const greyExtraLight = constants.colors.ui.neutral[25];

export const checkboxSectionCss: CSSObject = {
  display: "flex",
  flexWrap: "wrap",
  rowGap: ".5em",
  paddingTop: "1em",
  justifyContent: "flex-end",
  "& > div": {
    width: "50%",
    [mq.upTo(md)]: {
      width: "100%",
    },
  },
};

export const dateInputCss = mobileFirstCss({
  width: ["auto", "50%"],
});

export const sectionCss: CSSObject = {
  backgroundColor: greyExtraLight,
  margin: "-2em",
  marginTop: "2em",
  padding: "2em",
};
export const titleCss: CSSObject[] = [
  {
    margin: "16px 0",
    color: grey,
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  textXSObj,
];
